import { mainSiteUrl } from "@/mocks/categories";

export default function AboutSection() {
  const stats = [
    { value: "14+", label: "Product Categories" },
    { value: "2,000+", label: "Verified Listings" },
  ];

  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          {/* Left Text */}
          <div className="lg:w-1/2">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 leading-tight mb-5">
              What Is the{" "}
              <span className="text-primary-600">ACBuy Spreadsheet</span>{" "}
              and Why Global Buyers Rely on It
            </h2>
            <p className="text-foreground-700 leading-relaxed mb-4 text-sm md:text-base">
              The <strong>acbuy spreadsheet</strong> is a regularly updated product sourcing document that compiles verified supplier information, current pricing data, and organized product categories from Chinese marketplaces. Think of it as a curated sourcing assistant — instead of spending hours navigating marketplace listings in a foreign language, buyers simply open the spreadsheet and browse through clean, organized data.
            </p>
            <p className="text-foreground-700 leading-relaxed mb-4 text-sm md:text-base">
              Each entry in the <strong>acbuy spreadsheet</strong> has been reviewed for accuracy, ensuring that product descriptions match reality and supplier contacts are legitimate. This verification process significantly reduces the risks commonly associated with international sourcing — fake listings, misleading prices, and unreliable sellers.
            </p>
            <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
              Whether you are a first-time buyer testing the waters or an experienced importer scaling your operations, the <strong>acbuy spreadsheet</strong> provides a reliable foundation for making informed purchasing decisions. It is like having a sourcing expert on your team, continuously updating product data so you always work with the most current information available.
            </p>

            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-7 px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Explore Verified Product Lists
              <i className="ri-arrow-right-line"></i>
            </a>

            {/* Stats */}
            <div className="flex gap-12 md:gap-20 mt-12">
              {stats.map((stat) => (
                <div key={stat.label}>
                  <p className="text-3xl md:text-4xl font-bold text-foreground-900 font-heading">{stat.value}</p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right Card */}
          <div className="lg:w-1/2">
            <div className="relative rounded-[24px] overflow-hidden bg-background-100">
              <div className="aspect-[4/5]">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20workspace%20scene%20with%20laptop%20displaying%20spreadsheet%20data%20on%20screen%2C%20warm%20cream%20and%20beige%20tones%2C%20soft%20natural%20light%20from%20window%2C%20clean%20desk%20with%20coffee%20cup%2C%20editorial%20lifestyle%20photography%2C%20high%20end%20aesthetic%2C%20organized%20and%20calm%20atmosphere%2C%20organic%20textures&width=800&height=1000&seq=about-card-2026&orientation=portrait"
                  alt="A laptop showing the acbuy spreadsheet with organized product sourcing data for international buyers"
                  title="ACBuy Spreadsheet Workspace"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Overlay Tag */}
              <div className="absolute top-5 left-5">
                <span className="inline-block px-4 py-1.5 rounded-full bg-white/90 backdrop-blur-sm text-foreground-800 text-xs font-semibold whitespace-nowrap">
                  Updated June 2026
                </span>
              </div>
              {/* Bottom Info */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
                <p className="text-white text-sm font-semibold">ACBuy Spreadsheet</p>
                <p className="text-white/70 text-xs mt-1">Your trusted sourcing companion</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}